export default class ScriptLoader {
  static async load(url, el = document.head) {
    if (url.endsWith('.css')) {
      return this.loadCss(url, el);
    }

    if (url.endsWith('.js')) {
      return this.loadScript(url, el);
    }

    throw new Error('Invalid load url');
  }

  static loadScript(url, el = document.head) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('src', url);
      script.async = true;
      el.appendChild(script);
      script.onload = () => resolve();
      script.onerror = () => reject();
    });
  }

  static loadCss(url, el = document.head) {
    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('href', url);
      link.setAttribute('type', 'text/css');
      el.appendChild(link);
      link.onload = () => resolve();
      link.onerror = () => reject();
    });
  }
}
